
<b-container>
  <b-row class="justify-center py-5">
    <div class="col-12">
      <h1 class="display-4 align-center text-center">
        Order History
      </h1>
    </div>
  </b-row>
  <div v-if="!loading">
    <b-row v-if="orders.length > 0" class="justify-content-center pb-4">
      <b-col cols="12" sm="10">
        <b-list-group>
          <order
            v-for="(order, index) in orders"
            :key="index"
            :index="index"
            :order="order"
            @reorder="applyReorderItems"
          />
        </b-list-group>
      </b-col>
    </b-row>
    <b-container v-else>
      <b-row align-h="center" class="text-center pt-3">
        <p><b>Hey!</b> You haven't placed any orders yet.</p>
      </b-row>
      <b-row align-h="center" class="mt-3">
        <b-button class="btn-cta" to="/">
          Shop!
        </b-button>
      </b-row>
    </b-container>
    <b-row v-if="orders.length > 0" class="justify-content-center">
      <b-pagination
        v-model="currentPage"
        :per-page="itemsPerPage"
        :total-rows="totalOrders"
        pills
      />
    </b-row>
  </div>
  <b-row v-if="loading" align-h="center">
    <SmallSpinner :size="50" centered />
  </b-row>
</b-container>
